import React from 'react';
import SingleAction from './single-action';
import { notify } from 'legacy-packages/ft-cb';

const NOT_OWNER_ERROR_MESSAGE =
  'You are not the owner of this quiz. You can ask your co-teacher to share the quiz with you if you need to perform this action.';

const notifyError = () => notify.error(NOT_OWNER_ERROR_MESSAGE);

export const AssignPseudoAction = ({ showReassign }) => (
  <SingleAction
    isNaked
    onClick={notifyError}
    aria-label="Assign"
    iconName="assign"
  >
    <span className="item-text">
      {showReassign ? 'Reassign' : 'Assign'} Quiz
    </span>
  </SingleAction>
);

export const DuplicatePseudoAction = () => (
  <SingleAction
    isNaked
    onClick={notifyError}
    aria-label="Duplicate"
    iconName="duplicate"
  >
    <span className="item-text">Duplicate Quiz</span>
  </SingleAction>
);

export const EditPseudoAction = () => (
  <SingleAction
    isNaked
    onClick={() => {
      notify.error(NOT_OWNER_ERROR_MESSAGE);
    }}
    aria-label="Edit"
    iconName="edit"
  >
    <span className="item-text">Edit Quiz</span>
  </SingleAction>
);

export const SharePseudoAction = () => (
  <SingleAction
    isNaked
    onClick={() => {
      notify.error(NOT_OWNER_ERROR_MESSAGE);
    }}
    aria-label="Share Quiz"
    iconName="share_invite"
  >
    <span className="item-text">Share Quiz</span>
  </SingleAction>
);
